"use client";

import { createSlice } from "@reduxjs/toolkit";

type MessageHandlerState = {
  title: string | null;
  subtitle: string | null;
  type: string | null;
};

const slice = createSlice({
  name: "message-handler",
  initialState: {
    title: null,
    subtitle: null,
    type: null,
  } as MessageHandlerState,
  reducers: {
    setMessageHandler: (state, action) => {
      state.title = action.payload.title;
      state.subtitle = action.payload.subtitle;
      state.type = action.payload.type;
    },
    resetMessageHandler: (state) => {
      state.title = null;
      state.subtitle = null;
    },
  },
});

export const messageHandlerReducer = slice.reducer;
export const { resetMessageHandler, setMessageHandler } = slice.actions;
